"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _sql = _interopRequireDefault(require("refractor/lang/sql.js"));

;
var _default = _sql["default"];
exports["default"] = _default;